'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/lib/constants/LikeSize.js
// module id = 468
// module chunks = 0